import { Skeleton } from "@/components/ui/skeleton";
import type { ReactElement } from "react";

export function AdditionsListSkeleton(): ReactElement {
  return (
    <div className="space-y-3">
      {Array.from({ length: 2 }, (_, i) => (
        <div key={i} className="flex flex-row justify-between">
          <div className="flex min-h-9 items-center">
            <Skeleton className="h-4 w-40" />
          </div>
          <div className="flex min-h-9 items-center space-x-2">
            <Skeleton className="h-9 w-40" />
            <Skeleton className="h-9 w-9 rounded-md" />
          </div>
        </div>
      ))}
    </div>
  );
}
